import { mapData } from "@/stuff/DataMapping";
import utils from "@/stuff/Utils";

export interface ICertificateSuggestion {
    id: number;
    supplierID: number;
    certificateID: number;
    scopeID: number;
    created: Date;
}

export class CertificateSuggestion implements ICertificateSuggestion {

    constructor(data?: ICertificateSuggestion) {
        if (data) this.update(data);
    }

    update(data: ICertificateSuggestion): void {
        mapData(data, { root: () => this });
    }

    id: number = 0;
    supplierID: number = 0;
    certificateID: number = 0;
    scopeID: number = 0;
    created: Date = new Date(utils.emptyDateValue);

    supplier: string = "";
    certificate: string = "";
    scope: string = "";
    
}